module.exports = __webpack_public_path__ + "img/battery-charging.c8938dea.svg";